import React, { useCallback, useContext, useMemo, useState } from "react"
import { Row, Col } from "react-bootstrap"
import { Link, navigate } from "gatsby"

import { GlobalAuthContext } from "../../context/authContext"
import { getDateDuration } from "../../utils/getDateDuration"
import { DELETE_JOB } from "./job-actions"

const JobCardButtons = ({ data, show, setShow }) => {
  const [processing, setProcessing] = useState(false)
  const { state, dispatch } = useContext(GlobalAuthContext)

  const handleEditClick = () => {
    navigate(`/jobs/post-job/${data?.id}`)
  }

  const handleApllyOrSave = () => {
    navigate(`/jobs/${data?.id}`)
  }

  const handleDeleteClick = async () => {
    setShow(true)
    // setProcessing(true)
    // const res = await DELETE_JOB(data?.id)
    // if (res?.status === 204) {
    //   const filteredJobs = state?.job_posted_list?.results?.filter(
    //     job => job?.id !== data?.id
    //   )
    //   dispatch({
    //     type: "COMPANY_JOB_POSTED",
    //     payload: { ...state?.job_posted_list, results: filteredJobs },
    //   })
    //   setProcessing(false)
    // }
  }
  const date = useMemo(() => {
    return getDateDuration(data?.job_created)
  }, [data.job_created])

  const getPostedTimeDiff = useCallback(() => {
    if (date?.years > 0) {
      return date?.years + "y "
    } else if (date?.days > 0) {
      return date?.days + "d "
    } else if (date?.hours > 0) {
      return date?.hours + "h "
    } else if (date?.minutes > 0) {
      return date?.minutes + "m "
    } else {
      return "A while "
    }
  }, [date])

  return (
    <div className="card-buttons">
      <Row>
        <Col lg="12">
          <p>
            {getPostedTimeDiff()}
            since posted
          </p>
        </Col>
        {!!state?.user?.candidate?.id ? (
          <>
            {/* <Col lg="12">
              <button
                onClick={handleApllyOrSave}
                className="blue-background btn btn-small blue-outline rounded my-1"
              >
                Save
              </button>
            </Col> */}

            <Col lg="12">
              <button
                disabled={data?.applied_status}
                onClick={handleApllyOrSave}
                className=" btn btn-small blue-outline rounded"
              >
                {data?.applied_status ? "Applied" : "Apply"}
              </button>
            </Col>
          </>
        ) : !!state?.user?.company?.id ? (
          <>
            <Col lg="12">
              <button
                onClick={handleEditClick}
                className="blue-background btn btn-small blue-outline rounded my-1"
              >
                Edit
              </button>
            </Col>
            <Col lg="12">
              <button
                disabled={processing}
                onClick={handleDeleteClick}
                className="btn-red btn btn-small blue-outline rounded my-1"
              >
                {processing ? "Deleting..." : "Delete"}
              </button>
            </Col>
          </>
        ) : (
          <>
            {/* <Col lg="12">
              <Link to="/login">
                <button className="blue-background btn btn-small blue-outline rounded my-1">
                  Save
                </button>
              </Link>
            </Col> */}

            <Col lg="12">
              <Link to="/login">
                <button className=" btn btn-small blue-outline rounded">
                  Apply
                </button>
              </Link>
            </Col>
          </>
        )}
      </Row>
    </div>
  )
}

export default JobCardButtons
